"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    handleMessage: function() {
        return _handleMessage.handleMessage;
    },
    mergeData: function() {
        return _mergeData.mergeData;
    },
    ready: function() {
        return _ready.ready;
    },
    subscribe: function() {
        return _subscribe.subscribe;
    },
    unsubscribe: function() {
        return _unsubscribe.unsubscribe;
    }
});
const _handleMessage = require("./handleMessage");
const _mergeData = require("./mergeData");
const _ready = require("./ready");
const _subscribe = require("./subscribe");
const _unsubscribe = require("./unsubscribe");

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBoYW5kbGVNZXNzYWdlIH0gZnJvbSAnLi9oYW5kbGVNZXNzYWdlJ1xuZXhwb3J0IHsgbWVyZ2VEYXRhIH0gZnJvbSAnLi9tZXJnZURhdGEnXG5leHBvcnQgeyByZWFkeSB9IGZyb20gJy4vcmVhZHknXG5leHBvcnQgeyBzdWJzY3JpYmUgfSBmcm9tICcuL3N1YnNjcmliZSdcbmV4cG9ydCB7IHVuc3Vic2NyaWJlIH0gZnJvbSAnLi91bnN1YnNjcmliZSdcbiJdLCJuYW1lcyI6WyJoYW5kbGVNZXNzYWdlIiwibWVyZ2VEYXRhIiwicmVhZHkiLCJzdWJzY3JpYmUiLCJ1bnN1YnNjcmliZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7SUFBU0EsYUFBYTtlQUFiQSw0QkFBYTs7SUFDYkMsU0FBUztlQUFUQSxvQkFBUzs7SUFDVEMsS0FBSztlQUFMQSxZQUFLOztJQUNMQyxTQUFTO2VBQVRBLG9CQUFTOztJQUNUQyxXQUFXO2VBQVhBLHdCQUFXOzs7K0JBSlU7MkJBQ0o7dUJBQ0o7MkJBQ0k7NkJBQ0UifQ==